import { QueryRow } from './types'
import { useIsMobile } from '@duck/ui'
import { useTar } from '@/modules/i18n'
import { TableCellsIcon } from '@heroicons/react/24/outline'
import { StandardLoader } from '../StandardLoader'

interface QueryResultsDataProps {
  queryResults: QueryRow[] | null;
}

const mobileClasses = 'max-w-[100dvw]'

export const QueryResultsTable = ({ queryResults }: QueryResultsDataProps) => {
  const isMobile = useIsMobile()
  const { t } = useTar()

  if (!queryResults) {
    return (
      <div className="flex items-center justify-center h-full">
        <StandardLoader size="lg" />
      </div>
    )
  }
  if (queryResults.length === 0) {
    const desktopClasses = `h-full`

    return (
      <div
        className={`flex items-center justify-center ${isMobile ? mobileClasses : desktopClasses}`}
      >
        <div className="flex flex-col items-center justify-center space-y-3 text-center px-4">
          <TableCellsIcon className="w-12 h-12 text-muted-foreground/50" />
          <div className="space-y-1">
            <p className="text-sm font-medium text-foreground">
              {t('challenges.noQueryResults')}
            </p>
            <p className="text-xs text-muted-foreground">
              {t('challenges.noQueryResultsDescription')}
            </p>
          </div>
        </div>
      </div>
    )
  }
  const keys = Object.keys(queryResults[0])
  const desktopClasses = `h-full`

  return (
    <div className={`bg-card overflow-auto custom-scrollbar ${isMobile ? mobileClasses : desktopClasses}`}>
      <div className="text-sm min-w-[600px]">
        <div
          className="sticky top-0 bg-card border-b border-border z-[5] grid"
          style={{ gridTemplateColumns: `repeat(${keys.length}, minmax(0, 1fr))` }}
        >
          {keys.map((key) => (
            <div
              key={key}
              className="px-4 py-2 text-left text-foreground font-medium break-words"
            >
              {key}
            </div>
          ))}
        </div>
        <div>
          {queryResults.map((row, index) => (
            <div
              key={index}
              className={`grid border-b border-border ${index % 2 === 0 ? 'bg-card' : 'bg-card/50'}`}
              style={{ gridTemplateColumns: `repeat(${keys.length}, minmax(0, 1fr))` }}
            >
              {keys.map((key) => (
                <div key={key} className="px-4 py-2 text-foreground break-words">
                  {String(row[key])}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
